import { memo } from 'react'
import type { ResizeDirection } from '@/hooks/useTableResize'

interface TableResizeHandlesProps {
  onPointerDown: (event: React.PointerEvent<HTMLElement>, direction: ResizeDirection) => void
}

const handles: Array<{
  direction: ResizeDirection
  style: React.CSSProperties
}> = [
  { direction: 'e', style: { right: 0, top: '50%', transform: 'translate(50%, -50%)' } },
  { direction: 'w', style: { left: 0, top: '50%', transform: 'translate(-50%, -50%)' } },
]

export const TableResizeHandles = memo(function TableResizeHandles({
  onPointerDown,
}: TableResizeHandlesProps) {
  return (
    <>
      {handles.map(({ direction, style }) => (
        <button
          key={direction}
          type="button"
          aria-label={`Resize table ${direction}`}
          data-action="resize-table"
          data-export-exclude="true"
          onPointerDown={(event) => onPointerDown(event, direction)}
          style={{
            position: 'absolute',
            width: 10,
            height: 10,
            borderRadius: '50%',
            border: '2px solid #FFFFFF',
            background: '#4F46E5',
            boxShadow: '0 1px 5px rgba(15,23,42,.38)',
            padding: 0,
            zIndex: 20,
            cursor: `${direction}-resize`,
            touchAction: 'none',
            ...style,
          }}
        />
      ))}
    </>
  )
})
